import { FinancialTransactionsReportPmsApiService } from './transactions-report.service';

/**
 * @class AdjustmentsReportPmsApiService
 * @extends {AbstractReportPmsApiService<FinancialTransactionReport>}
 */
export class AdjustmentsReportPmsApiService extends FinancialTransactionsReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/report/financial/adjustments';
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/adjustments-report.service.js